import { useEffect, useState } from "react";
import { _ProjectSchedule } from "../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { TaskHistory } from "./TaskHistory";
import { DropDown } from "../../theme/Component/DropDown";
import AutoChart from "../../../core/graph/AutoChart";
import { SelectProject } from "../cellEditor/BudgetAccountantOperation/SelectProject";
import { BasicButton } from "../../theme/Component/BasicButton";
import { AccountEditor } from "../../editor/AccountEditor";

interface Props {
    asView: boolean;
}
export const ProjectScheduleTask = ({ asView }: Props) => {

    const _schedule = useDataBean(_ProjectSchedule);
    const { lista, setLista, bean, setBean, instance } = _schedule;
    const [data, setData] = useState<any>({});
    const modalHistory = useModal("Historial", MODAL_LG);
    const modalActividad = useModal("Historial", MODAL_LG);
    const modalGraph = useModal("Grafica", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        let filter: any = {

        };
        if (!asView) {
            filter.IDAccountResponsible = _single.getAccountID()
        }else{
            if(data.IDProject)
            {
                filter.IDProject = data.IDProject 
            }
            if(data.IDAccountResponsible)
            {
                filter.IDAccountResponsible = data.IDAccountResponsible 
            }
        }
        instance.getProjectScheduleRender(1, 2000, filter).then(
            (resp: any) => {
                setLista(resp.List);
            }
        )
    }

    const iniciarTarea = () => {
        let data = {
            Description: "Tarea Iniciada",
            AttachmentList: JSON.stringify([])
        }
        instance.responseTask(bean.IDProjectSchedule, _single.getAccountID(), 4, data).then(
            (resp: any) => {
                getLista();
                toast.success("Tarea Iniciada");
            }
        )
    }
    const registrarActividad = () => {

        modalActividad.open();
        setData({
            Type: 4,
            Description: ''
        });

    }
    const updateTask = () => {
        let dataService: any = {
            Description: data.Description,
            AttachmentList: JSON.stringify([])
        }
        instance.responseTask(bean.IDProjectSchedule, _single.getAccountID(), data.Type, dataService).then(
            (resp: any) => {
                getLista();
                toast.success("Tarea Actualizada");
                modalActividad.close();
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProjectSchedule', visible: false, mask: MASK_NUMBER },
        { title: 'Codigo Proyecto', property: 'Code', visible: true },
        { title: 'Nombre Proyecto', property: 'Name', visible: true },
        { title: 'Responsable', property: 'IDAccountResponsibleName', visible: true },
        { title: 'Area Responsable', property: 'NameArea', visible: true },
        { title: 'Actividad', property: 'Objective', visible: true },
        { title: 'Fecha Inicial', property: 'FromDate', visible: true },
        { title: 'Fecha Final', property: 'UptoDate', visible: true },
        { title: 'Dias', property: 'Days', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Iniciar Tarea', icono: 'ri-file-add-line', visible: [1].includes(bean.State) && !asView, evento: iniciarTarea },
            { titulo: 'Registrar Actividad', icono: 'ri-file-add-line', visible: [4].includes(bean.State) && !asView, evento: registrarActividad },
            { titulo: 'Historial Actividades', icono: 'ri-file-add-line', visible: true, evento: () => modalHistory.open() },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Actividades de proyecto">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">
                            <SelectProject label="Proyecto" idSelector={data.IDProject} onChange={(e)=>{setData({...data,"IDProject":e})}}/>
                        </div>
                        <div className="col-md-6">
                            <AccountEditor label="Responsable" idAccount={data.IDAccountResponsible} onChange={({IDAccount}:any)=>{setData({...data,"IDAccountResponsible":IDAccount})}}/>
                        </div>
                        <div className="col-md-12">
                            <BasicButton icon="" clase="danger" eventClick={()=>{setData({})}}>Limpiar</BasicButton>
                            <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">

                    <BasicTable headButtons={buttons()} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean}></BasicTable>

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal}>
                        <TaskHistory idProjectSchedule={bean.IDProjectSchedule} />
                    </Modal>
                    <Modal modal={modalActividad.modal} updateModal={modalActividad.setModal} eventModal={updateTask} onSubmitLabel="Actualizar">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Tipo Actividad</label>
                                <select className="form-select" value={data.Type} onChange={(e) => { setData({ ...data, "Type": parseInt(e.target.value) }) }}>
                                    <option value={4}>EN EJECUCION</option>
                                    <option value={3}>COMPLETADA</option>
                                    <option value={6}>CANCELADA</option>
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción de la actividad</label>
                                <textarea name="des" className="form-control" value={data.Description} onChange={(e) => { setData({ ...data, "Description": e.target.value }) }}></textarea>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['Code', 'IDAccountResponsibleName', 'NameArea', 'StateName']}
                            yOptions={['IDAccountResponsibleName', 'Days', 'StateName', 'Objective']} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}